import React from 'react'
import { View, Text } from 'react-native'

export default function HiComponent() {
    return (
        <View>
            <Text>HiComponent</Text>
        </View>
    )
}
